import { init as initSaola } from '@saola.ai/browser';

initSaola('05da12e5-3202-46ce-8dd5-767628079708');
